/* Ask Kitch — routes plain-language questions to the right mykitch.ca page.
 * No AI service, no cost per search, nothing sent off-site.
 * 1. Curated intent table (ROUTES) scored against the question.
 * 2. City detection -> the matching city page.
 * 3. Blog articles (injected by the section) matched on title words.
 * 4. Shopify predictive search as a live fallback.
 * Every search fires an "ask_kitch_search" event (dataLayer / gtag / Shopify pixel)
 * so the team can see what people ask and what went unanswered.
 * The header search icon scrolls to the homepage section (#ask-kitch) when it is on the page,
 * otherwise it opens the site-wide pop-up (snippets/kitch-ask-modal.liquid).
 */
(function () {
  'use strict';
  if (window.__kitchAskLoaded) return; // section + pop-up both include this file
  window.__kitchAskLoaded = true;

  var ORDER_HUB = 'https://mykitch.allmoxy.com/public/order/';

  // w = weight. Phrases (with spaces) score higher than single words.
  var ROUTES = [
    { id: 'cost', t: 'Cost Estimator', u: '/pages/cost-calculator',
      d: 'Get a ballpark price for your kitchen in a couple of minutes.',
      k: { 'cost': 5, 'price': 5, 'pricing': 5, 'how much': 6, 'budget': 5, 'estimate': 5, 'estimator': 6, 'calculator': 6, 'quote': 4, 'afford': 3, 'expensive': 3, 'cheap': 3, 'ballpark': 5, 'spend': 3, 'total': 2 } },

    { id: 'smd', t: 'Start My Design', u: '/products/start-my-design',
      d: 'Work with a Kitch designer to plan your layout and get a full quote.',
      k: { 'design': 3, 'designer': 6, 'design help': 7, 'help designing': 7, 'help me design': 7, 'design service': 7, 'design project': 7, 'start my design': 9, 'start a design': 8, 'layout': 5, 'floor plan': 5, 'plan my kitchen': 6, 'dont know where to start': 6, 'where to start': 5, 'consult': 4, 'consultation': 5, 'someone to help': 5, 'help me plan': 6, 'renovation': 2, 'renovate': 2, 'remodel': 2, 'new kitchen': 3 } },

    { id: 'bmc', t: 'Build My Cart', u: '/products/build-my-design',
      d: 'Already have your plan? Send it over and we build your order for you.',
      k: { 'build my cart': 9, 'build my design': 9, 'build my order': 8, 'build your order': 7, 'we build': 6, 'have a plan': 6, 'have my plan': 6, 'have a design': 6, 'ikea plan': 6, 'ikea planner': 7, 'planner': 4, 'already designed': 6, 'already planned': 6, 'send my plan': 7, 'my drawings': 5, 'convert': 4 } },

    { id: 'diy', t: 'Build your order yourself', u: '/pages/get-start-building-your-order',
      d: 'Know exactly what you need? Here is how to place your own order.',
      k: { 'order myself': 8, 'place an order': 6, 'place my order': 6, 'place order': 6, 'start my order': 7, 'start an order': 7, 'diy': 5, 'do it myself': 6, 'self serve': 5, 'buy doors': 5, 'buy': 2, 'order': 2, 'purchase': 3, 'checkout': 3 } },

    { id: 'hub', t: 'Order Hub sign-in', u: ORDER_HUB,
      d: 'Existing customers: sign in to see, edit or track your order.',
      k: { 'order hub': 9, 'orderhub': 9, 'sign in': 7, 'signin': 7, 'log in': 7, 'login': 7, 'my account': 6, 'account': 3, 'track': 6, 'tracking': 6, 'order status': 8, 'where is my order': 9, 'my order': 3, 'existing order': 7, 'portal': 6, 'password': 5, 'invoice': 5, 'reorder': 5 } },

    { id: 'ikea', t: 'Doors for IKEA® SEKTION', u: '/pages/sektion-for-kitchen-and-bathroom',
      d: 'Custom Kitch doors and panels made to fit IKEA SEKTION cabinets.',
      k: { 'ikea': 5, 'sektion': 7, 'metod': 5, 'ikea kitchen': 7, 'ikea cabinets': 7, 'ikea doors': 7, 'fit ikea': 7, 'upgrade': 3, 'replace doors': 6, 'replacement doors': 6, 'new doors': 5, 'reface': 5, 'refacing': 5, 'existing cabinets': 5 } },

    { id: 'box', t: 'KitchBOX cabinet system', u: '/pages/kitch-cabinet-box',
      d: "Our own modular cabinet boxes, for when IKEA isn't an option.",
      k: { 'kitchbox': 9, 'kitch box': 9, 'cabinet box': 7, 'cabinet boxes': 7, 'boxes': 4, 'box': 2, 'carcass': 6, 'carcasses': 6, 'no ikea': 8, 'without ikea': 8, 'dont have ikea': 8, 'cant get ikea': 8, 'not ikea': 6, 'cabinets': 2, 'modular': 4, 'whole kitchen': 4, 'full kitchen': 4 } },

    { id: 'styles', t: 'Door styles', u: '/pages/styles-finishes',
      d: 'Slab, Euro Slab, Shaker, Deco, Gruv and more, with every colour option.',
      k: { 'style': 5, 'styles': 5, 'door style': 7, 'door styles': 7, 'door fronts': 6, 'door front': 6, 'doors': 3, 'door': 2, 'fronts': 4, 'shaker': 6, 'slab': 6, 'euro slab': 7, 'deco': 6, 'gruv': 7, 'fluted': 5, 'twigg': 7, 'branch': 4, 'bevel': 6, 'slim': 3, 'slender': 5, 'signature': 3, 'profile': 4, 'look': 1, 'options': 2, 'panels': 3, 'end panel': 5 } },

    { id: 'finishes', t: 'Finishes & colours', u: '/pages/finishes',
      d: 'Supermatte, woodgrain and veneer finishes, side by side.',
      k: { 'finish': 6, 'finishes': 6, 'colour': 6, 'colours': 6, 'color': 6, 'colors': 6, 'paint': 3, 'painted': 3, 'white': 3, 'black': 3, 'green': 3, 'grey': 3, 'gray': 3, 'navy': 3, 'blue': 3, 'beige': 3, 'cream': 3, 'supermatte': 7, 'two tone': 4 } },

    { id: 'wood', t: 'Woodgrain finishes', u: '/pages/woodgrain',
      d: 'Oak and walnut-look woodgrain finishes.',
      k: { 'woodgrain': 8, 'wood grain': 8, 'wood': 5, 'oak': 6, 'walnut': 6, 'natural': 3, 'timber': 5 } },

    { id: 'matte', t: 'Matte finishes', u: '/pages/matte',
      d: 'Smooth, fingerprint-resistant matte colours.',
      k: { 'matte': 8, 'matt': 7, 'flat finish': 6, 'fingerprint': 5, 'fingerprints': 5 } },

    { id: 'veneer', t: 'Shinnoki veneer', u: '/pages/shinnoki-veneer',
      d: 'Real wood veneer fronts from Shinnoki.',
      k: { 'veneer': 8, 'shinnoki': 9, 'real wood': 7 } },

    { id: 'glass', t: 'Decorative glass doors', u: '/pages/decorative-glass-door',
      d: 'Glass-insert doors for display cabinets.',
      k: { 'glass': 8, 'glass door': 9, 'display cabinet': 6, 'insert': 4 } },

    { id: 'samples', t: 'Order samples', u: '/collections/samples',
      d: 'See and feel door styles and finishes at home before you commit.',
      k: { 'sample': 7, 'samples': 7, 'swatch': 6, 'swatches': 6, 'see in person': 6, 'try': 2, 'feel': 3, 'before i buy': 5, 'before buying': 5, 'chip': 3 } },

    { id: 'sampleboxes', t: 'Signature Sample Box', u: '/products/kresswell-interiors-sample-box',
      d: 'The Kresswell Interiors x Kitch curated box of finishes.',
      k: { 'sample box': 9, 'sample boxes': 9, 'sample kit': 8, 'premium sample': 7, 'kresswell box': 6, 'signature samples': 7 } },

    { id: 'guide', t: 'The Sample Example Guide', u: '/pages/sample-guide',
      d: 'Free guide: how our finishes look together in real kitchens.',
      k: { 'guide': 3, 'sample guide': 9, 'lookbook': 7, 'free guide': 7, 'inspiration guide': 7, 'download': 3, 'pdf': 3, 'combinations': 5, 'combo': 5, 'pair': 3, 'go together': 5 } },

    { id: 'shipping', t: 'Shipping options', u: '/pages/shipping-options',
      d: 'Carry-in, curbside and courier delivery across Canada.',
      k: { 'ship': 5, 'shipping': 6, 'deliver': 5, 'delivery': 6, 'carry in': 6, 'curbside': 7, 'courier': 6, 'freight': 5, 'flat pack': 5, 'flat packed': 5, 'arrive': 3 } },

    { id: 'shipcost', t: 'Shipping estimator', u: '/pages/threshold-shipping',
      d: 'See the delivery zone and shipping price for your postal code.',
      k: { 'shipping cost': 9, 'cost to ship': 9, 'shipping price': 9, 'delivery cost': 9, 'delivery fee': 8, 'shipping zone': 8, 'shipping zones': 8, 'postal code': 7, 'zone': 4, 'shipping estimate': 9, 'how much shipping': 9 } },

    { id: 'areas', t: 'Where we deliver', u: '/pages/service-areas',
      d: 'Find your city: we deliver Canada-wide.',
      k: { 'service area': 9, 'service areas': 9, 'where do you': 5, 'my city': 7, 'my area': 7, 'near me': 7, 'canada': 4, 'province': 5, 'ship to': 6, 'deliver to': 6, 'location': 4, 'locations': 4, 'usa': 4, 'united states': 5, 'america': 4, 'showroom': 5 } },

    { id: 'timeline', t: 'How long it takes', u: '/blogs/blog/ikea-kitchen-timeline-custom-fronts',
      d: 'Typical timeline from order to delivery.',
      k: { 'how long': 6, 'lead time': 9, 'leadtime': 9, 'turnaround': 8, 'timeline': 8, 'weeks': 5, 'when will': 5, 'wait': 3, 'production time': 8, 'eta': 5 } },

    { id: 'how', t: 'How it works', u: '/pages/get-started',
      d: 'The Kitch process, step by step: plan, sample, order, install.',
      k: { 'how it works': 9, 'how does it work': 9, 'how does kitch work': 9, 'process': 6, 'steps': 5, 'get started': 7, 'getting started': 7, 'start': 2, 'first time': 5, 'new here': 6, 'what is kitch': 7, 'what do you do': 6, 'what do you sell': 7 } },

    { id: 'partners', t: 'Find an installer or designer', u: '/pages/progus-store-locator',
      d: 'Kitch partner installers and designers near you.',
      k: { 'installer': 8, 'installers': 8, 'install': 5, 'installation': 6, 'contractor': 7, 'contractors': 7, 'trades': 5, 'carpenter': 6, 'handyman': 6, 'someone to install': 9, 'who can install': 9, 'partner': 4, 'partners': 4, 'kitchen designer': 7, 'interior designer': 6, 'near me': 2 } },

    { id: 'partnerup', t: 'Become a Kitch partner', u: '/pages/partner-sign-up',
      d: 'For designers, builders and trades who want to work with Kitch.',
      k: { 'become a partner': 9, 'trade program': 9, 'trade account': 9, 'trade discount': 8, 'i am a designer': 8, 'im a designer': 8, 'i am a contractor': 8, 'im a contractor': 8, 'builder': 5, 'wholesale': 7, 'dealer': 7, 'resell': 6, 'affiliate': 6, 'join': 3, 'apply': 3 } },

    { id: 'assembly', t: 'Assembly guides', u: '/pages/assembly-guides',
      d: 'Step-by-step instructions for putting your order together.',
      k: { 'assemble': 7, 'assembly': 8, 'instructions': 7, 'how to install': 8, 'install doors': 7, 'put together': 7, 'hang doors': 6, 'hinge': 3, 'adjust': 4, 'manual': 5 } },

    { id: 'kbvideo', t: 'KitchBOX assembly video', u: '/pages/kitchbox-assembly-video',
      d: 'Watch a KitchBOX cabinet go together.',
      k: { 'video': 6, 'kitchbox assembly': 9, 'assembly video': 9, 'watch': 4 } },

    { id: 'measure', t: 'How to measure your cabinets', u: '/blogs/blog/how-to-measure-ikea-sektion-cabinets',
      d: 'Measure your IKEA SEKTION boxes for new doors, step by step.',
      k: { 'measure': 8, 'measuring': 8, 'measurements': 7, 'dimensions': 5, 'size': 3, 'sizes': 3, 'fit': 3, 'will it fit': 7 } },

    { id: 'shelves', t: 'Floating shelves', u: '/pages/floating-shelves',
      d: 'Floating shelves made to match your finishes.',
      k: { 'shelf': 7, 'shelves': 8, 'floating': 7, 'open shelving': 8 } },

    { id: 'bath', t: 'Bathroom vanities', u: '/pages/bathroom',
      d: 'Doors and fronts for IKEA GODMORGON and SEKTION bathroom vanities.',
      k: { 'bathroom': 8, 'bath': 6, 'vanity': 8, 'vanities': 8, 'godmorgon': 9, 'ensuite': 7, 'powder room': 7, 'washroom': 7 } },

    { id: 'rooms', t: 'Cabinets for every room', u: '/pages/cabinets-for-every-room',
      d: 'Closets, laundry, mudroom, office, media walls and more.',
      k: { 'closet': 7, 'wardrobe': 7, 'pax': 8, 'laundry': 7, 'mudroom': 7, 'office': 5, 'media': 5, 'tv': 5, 'besta': 8, 'entertainment': 5, 'pantry': 5, 'garage': 5, 'bedroom': 5, 'built in': 5, 'built ins': 5, 'every room': 6 } },

    { id: 'kitchen', t: 'Kitchens', u: '/pages/kitchen',
      d: 'Kitch kitchens: doors, panels and cabinets.',
      k: { 'kitchen': 2, 'kitchens': 2, 'island': 4 } },

    { id: 'gallery', t: 'Project gallery', u: '/pages/gallery',
      d: 'Real Kitch kitchens and bathrooms from customers and designers.',
      k: { 'gallery': 8, 'photos': 7, 'pictures': 7, 'inspiration': 7, 'ideas': 5, 'examples': 6, 'real kitchens': 7, 'before and after': 7, 'projects': 5, 'see kitchens': 6 } },

    { id: 'faq', t: 'FAQ', u: '/pages/faq',
      d: 'Answers to the questions we get most.',
      k: { 'faq': 9, 'faqs': 9, 'questions': 4, 'question': 3 } },

    { id: 'warranty', t: 'Warranty', u: '/pages/warranty',
      d: 'What our warranty covers.',
      k: { 'warranty': 9, 'guarantee': 7, 'damaged': 6, 'damage': 6, 'defect': 7, 'broken': 5, 'chipped': 6, 'peeling': 6 } },

    { id: 'returns', t: 'Refund policy', u: '/policies/refund-policy',
      d: 'Returns, cancellations and refunds.',
      k: { 'refund': 9, 'refunds': 9, 'return': 7, 'returns': 7, 'cancel': 7, 'cancellation': 7, 'exchange': 6 } },

    { id: 'assurance', t: 'Order Assurance Policy', u: '/pages/order-assurance-policy',
      d: 'How we make sure your order is right.',
      k: { 'order assurance': 9, 'assurance': 7, 'wrong size': 6, 'mistake': 5 } },

    { id: 'contact', t: 'Contact & help', u: '/pages/help-centre',
      d: 'Talk to the Kitch team.',
      k: { 'contact': 8, 'phone': 7, 'call': 4, 'email': 6, 'talk to': 6, 'speak to': 6, 'human': 6, 'person': 4, 'help': 2, 'support': 6, 'customer service': 8, 'hours': 4, 'address': 4 } },

    { id: 'call', t: 'Book a discovery call', u: 'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ3lmmIVZyg71JLAjg6WHaA-Rdzf6jGTCXUfdWEbu5giIf-ZInijJ-55yRwtR8yymW7kgtoNuSaL', ext: true,
      d: 'Book a free call with the Kitch team.',
      k: { 'discovery call': 9, 'book a call': 9, 'book call': 8, 'appointment': 7, 'book': 3, 'meeting': 5, 'video call': 7, 'zoom': 6, 'schedule': 5 } },

    { id: 'about', t: 'About Kitch', u: '/pages/about',
      d: 'Made in Edmonton since 2017.',
      k: { 'about': 5, 'who are you': 7, 'company': 4, 'edmonton': 3, 'made in canada': 7, 'canadian': 5, 'local': 3, 'where are you': 5, 'story': 4, 'founded': 5 } },

    { id: 'kresswell', t: 'Kresswell Interiors x Kitch', u: '/pages/kresswell-interiors',
      d: 'The Signature Edit collaboration.',
      k: { 'kresswell': 9, 'signature edit': 9, 'collab': 5, 'collaboration': 5 } },

    { id: 'tiffany', t: 'Kitch + Tiffany Pratt', u: '/pages/tiffany-pratt',
      d: 'Our collaboration with Tiffany Pratt.',
      k: { 'tiffany': 9, 'pratt': 9 } },

    { id: 'careers', t: 'Careers', u: '/pages/career',
      d: 'Work with us.',
      k: { 'career': 9, 'careers': 9, 'job': 8, 'jobs': 8, 'hiring': 8, 'work for': 7 } },

    { id: 'hinges', t: 'Do custom IKEA doors need special hinges?', u: '/blogs/blog/ikea-sektion-hinges',
      d: 'Hinges, hardware and what carries over from IKEA.',
      k: { 'hinges': 8, 'hinge': 6, 'soft close': 7, 'hardware': 5, 'handles': 5, 'pulls': 5, 'knobs': 5 } },

    { id: 'clean', t: 'Cleaning guide (PDF)', u: 'https://cdn.shopify.com/s/files/1/0639/8686/0263/files/Kitch_Cleaning_Guide.pdf?v=1748455932', ext: true,
      d: 'How to clean and care for your fronts.',
      k: { 'clean': 8, 'cleaning': 8, 'care': 5, 'maintain': 6, 'maintenance': 6, 'wipe': 5 } }
  ];

  // City pages. c = cabinets page handle, d = door-fronts handle, f = finishes handle.
  var CITIES = [
    ['Calgary', 'kitchen-cabinet-products-calgary', 'door-fronts-in-calgary', 'finishes-in-calgary', ['yyc']],
    ['Edmonton', 'kitchen-cabinet-products-edmonton', 'door-fronts-in-edmonton', 'finishes-in-edmonton', ['yeg', 'st albert', 'sherwood park', 'spruce grove', 'leduc']],
    ['Vancouver', 'kitchen-cabinet-products-vancouver', 'door-fronts-in-vancouver', 'finishes-in-vancouver', ['yvr', 'burnaby', 'surrey', 'north vancouver', 'coquitlam', 'langley']],
    ['Victoria', 'kitchen-cabinet-products-victoria', 'door-fronts-in-victoria', 'finishes-in-victoria', ['vancouver island', 'nanaimo']],
    ['Kelowna', 'kitchen-cabinet-products-kelowna', 'door-fronts-in-kelowna', 'finishes-in-kelowna', ['okanagan', 'penticton', 'vernon']],
    ['Prince Rupert', 'kitchen-cabinet-products-in-prince-rupert', 'door-fronts-in-prince-rupert', 'finishes-in-prince-rupert', []],
    ['Dawson Creek', 'kitchen-cabinet-products-in-dawson-creek', 'door-fronts-in-dawson-creek', 'finishes-in-dawson-creek', ['fort st john', 'grande prairie']],
    ['Whitehorse', 'kitchen-cabinet-products-in-whitehorse', 'door-fronts-in-whitehorse', 'finishes-in-whitehorse', ['yukon']],
    ['Yellowknife', 'kitchen-cabinet-products-in-yellowknife', 'door-fronts-in-yellowknife', 'finishes-in-yellowknife', ['nwt', 'northwest territories']],
    ['Regina', 'kitchen-cabinet-products-regina', 'door-fronts-in-regina', 'finishes-in-regina', []],
    ['Saskatoon', 'kitchen-cabinet-products-saskatoon', 'door-fronts-in-saskatoon', 'finishes-in-saskatoon', []],
    ['Toronto', 'kitchen-cabinet-products-toronto', 'door-fronts-in-toronto', 'finishes-in-toronto', ['gta', 'scarborough', 'etobicoke', 'north york']],
    ['Mississauga', 'kitchen-cabinet-products-mississauga', 'door-fronts-in-mississauga', 'finishes-in-mississauga', ['brampton']],
    ['Vaughan', 'kitchen-cabinet-products-vaughan-ontario', 'door-fronts-in-vaughan', 'finishes-in-vaughan', ['woodbridge']],
    ['Markham', 'custom-cabinets-markham', 'door-fronts-in-markham', 'finishes-in-markham', []],
    ['Richmond Hill', 'kitchen-cabinet-products-in-richmond-hill', 'door-fronts-in-richmond-hill', null, []],
    ['Oakville', 'kitchen-cabinet-products-oakville', 'door-fronts-in-oakville', 'finishes-in-oakville', []],
    ['Burlington', 'kitchen-cabinet-products-burlington', 'door-fronts-in-burlington', 'finishes-in-burlington', []],
    ['Hamilton', 'kitchen-cabinet-products-hamilton', 'door-fronts-in-hamilton', 'finishes-in-hamilton', []],
    ['Oshawa', 'kitchen-cabinet-products-oshawa', 'door-fronts-in-oshawa', 'finishes-in-oshawa', ['whitby', 'ajax', 'pickering', 'durham']],
    ['Kitchener', 'kitchen-cabinet-products-kitchener', 'door-fronts-in-kitchener', 'finishes-in-kitchener', ['kw', 'cambridge']],
    ['Waterloo', 'custom-cabinets-waterloo', 'door-fronts-in-waterloo', 'finishes-in-waterloo', []],
    ['Guelph', 'kitchen-cabinet-products-guelph', 'door-fronts-in-guelph', 'finishes-in-guelph', []],
    ['Kingston', 'kitchen-cabinet-products-kingston', 'door-fronts-in-kingston', 'finishes-in-kingston', []],
    ['Ottawa', 'kitchen-cabinet-products-ottawa', 'door-fronts-in-ottawa', 'finishes-in-ottawa', ['gatineau', 'kanata', 'orleans']],
    ['Sudbury', 'kitchen-cabinet-products-greater-sudbury', 'door-fronts-in-sudbury', 'finishes-in-sudbury', ['greater sudbury']],
    ['Montreal', 'kitchen-cabinet-products-montreal', 'door-fronts-in-montreal', 'finishes-in-montreal', ['mtl', 'laval', 'longueuil']],
    ['Quebec City', 'kitchen-cabinet-products-quebec-city', 'door-fronts-in-quebec-city', 'finishes-in-quebec-city', ['quebec city', 'ville de quebec']],
    ['Moncton', 'kitchen-cabinet-products-greater-moncton', 'door-fronts-in-moncton', 'finishes-in-moncton', ['dieppe', 'new brunswick']],
    ["St. John's", 'kitchen-cabinet-products-st-johns', 'door-fronts-in-st-johns', 'finishes-in-st-johns', ['st johns', 'saint johns', 'newfoundland']]
  ];

  var STOP = ('a an the i im me my we our you your to for of in on at and or is are do does can could would should will ' +
    'it its this that with about get want need looking look like just some any be have has am what which how ' +
    'please pls hi hello hey there kitch yall thanks thank so if from by').split(' ');
  var STOPSET = {};
  STOP.forEach(function (w) { STOPSET[w] = 1; });

  function norm(s) {
    return (s || '').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/®|™/g, '')
      .replace(/['’`]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }
  function stem(w) {
    if (w.length > 4 && /ies$/.test(w)) return w.slice(0, -3) + 'y';
    if (w.length > 4 && /(ches|shes|xes|sses)$/.test(w)) return w.slice(0, -2);
    if (w.length > 3 && /s$/.test(w) && !/ss$/.test(w)) return w.slice(0, -1);
    return w;
  }
  function words(s) { return norm(s).split(' ').filter(Boolean); }
  function hasPhrase(padded, phrase) { return padded.indexOf(' ' + phrase + ' ') !== -1; }

  // Pre-normalise routes
  ROUTES.forEach(function (r) {
    var seenStem = {};
    r.keys = [];
    Object.keys(r.k).forEach(function (key) {
      var n = norm(key);
      var st = n.split(' ').map(stem).join(' ');
      if (seenStem[st]) { seenStem[st].w = Math.max(seenStem[st].w, r.k[key]); return; } // "contractor"/"contractors" count once
      var k = { raw: n, stemmed: st, w: r.k[key], multi: n.indexOf(' ') !== -1 };
      seenStem[st] = k;
      r.keys.push(k);
    });
  });

  // Context rules that plain keyword scores can't express.
  var SHIPWORDS = /\s(ship|shipping|shipped|deliver|delivery|delivered|freight|courier)\s/;
  var COSTWORDS = /\s(cost|costs|price|prices|pricing|fee|fees|how much|charge|rate|rates|estimate)\s/;
  var NEG_IKEA = /\s(no|dont|do not|not|without|cant|cannot|can not|never|arent|isnt|havent)\s(\w+\s){0,3}ikea\s/;
  function adjust(id, s, padded) {
    if (id === 'shipcost' && SHIPWORDS.test(padded) && COSTWORDS.test(padded)) s += 12;
    if (id === 'cost' && SHIPWORDS.test(padded)) s -= 6;
    if (id === 'ikea' && NEG_IKEA.test(padded)) s -= 12;
    if (id === 'box' && NEG_IKEA.test(padded)) s += 6;
    return s;
  }

  function scoreRoutes(q) {
    var n = norm(q);
    var ws = n.split(' ').filter(Boolean);
    var padded = ' ' + n + ' ';
    var stemmedPadded = ' ' + ws.map(stem).join(' ') + ' ';
    var out = [];
    ROUTES.forEach(function (r) {
      var s = 0, hits = 0;
      r.keys.forEach(function (k) {
        if (hasPhrase(padded, k.raw) || hasPhrase(stemmedPadded, k.stemmed)) {
          s += k.multi ? k.w + 2 : k.w; hits++;
        }
      });
      // Prefix match on the last word while the user is still typing ("finis" -> finishes)
      var last = ws[ws.length - 1];
      if (!s && last && last.length >= 4) {
        r.keys.forEach(function (k) {
          if (!k.multi && k.raw.indexOf(last) === 0 && k.w >= 5) { s = Math.max(s, k.w - 2); hits = 1; }
        });
      }
      s = adjust(r.id, s, padded);
      if (s > 0) out.push({ r: r, s: s + hits * 0.25 });
    });
    return out;
  }

  function findCity(q) {
    var padded = ' ' + norm(q) + ' ';
    for (var i = 0; i < CITIES.length; i++) {
      var c = CITIES[i];
      var names = [norm(c[0])].concat(c[4].map(norm));
      for (var j = 0; j < names.length; j++) {
        if (names[j] && padded.indexOf(' ' + names[j] + ' ') !== -1) return c;
      }
    }
    return null;
  }

  function cityResults(city, q) {
    var n = ' ' + norm(q) + ' ';
    var wantDoors = /\s(door|doors|front|fronts|style|styles|shaker|slab)\s/.test(n);
    var wantFinish = /\s(finish|finishes|colou?rs?|woodgrain|matte|oak|walnut)\s/.test(n);
    var list = [
      { t: 'Kitch in ' + city[0], u: '/pages/' + city[1], d: 'Cabinets, delivery and local info for ' + city[0] + '.', s: 20 },
      { t: 'Door fronts in ' + city[0], u: '/pages/' + city[2], d: 'Door styles delivered to ' + city[0] + '.', s: wantDoors ? 40 : 12 }
    ];
    if (city[3]) list.push({ t: 'Finishes in ' + city[0], u: '/pages/' + city[3], d: 'Colours and finishes delivered to ' + city[0] + '.', s: wantFinish ? 40 : 11 });
    return list;
  }

  function scoreArticles(q, articles) {
    var qw = words(q).filter(function (w) { return !STOPSET[w] && w.length > 2; }).map(stem);
    if (!qw.length) return [];
    var out = [];
    articles.forEach(function (a) {
      var aw = words(a.t + ' ' + (a.k || '')).map(stem);
      var set = {};
      aw.forEach(function (w) { set[w] = 1; });
      var hit = 0;
      qw.forEach(function (w) { if (set[w]) hit++; });
      if (hit >= 2 || (hit === 1 && qw.length === 1)) {
        out.push({ t: a.t, u: a.u, d: 'From The Hack, the Kitch blog', s: hit * 3 / Math.sqrt(qw.length), article: true });
      }
    });
    out.sort(function (a, b) { return b.s - a.s; });
    return out.slice(0, 3);
  }

  function resolve(q, articles) {
    var results = [];
    var seen = {};
    function add(x) { if (!seen[x.u]) { seen[x.u] = 1; results.push(x); } }

    var city = findCity(q);
    var routes = scoreRoutes(q);
    // A city mention outranks generic shipping/area routes
    if (city) routes = routes.filter(function (x) { return ['areas', 'shipping'].indexOf(x.r.id) === -1 || x.s < 6; });
    var cands = routes.map(function (x) { return { t: x.r.t, u: x.r.u, d: x.r.d, s: x.s, ext: x.r.ext, id: x.r.id }; });
    if (city) cands = cands.concat(cityResults(city, q));
    cands.sort(function (a, b) { return b.s - a.s; });
    cands.forEach(add);

    var arts = scoreArticles(q, articles || []);
    return { pages: results.slice(0, 5), articles: arts.filter(function (a) { return !seen[a.u]; }).slice(0, 3), city: city };
  }

  // Exposed for testing
  window.KitchAsk = { resolve: resolve, norm: norm, ROUTES: ROUTES };

  // ---------- Analytics ----------
  function track(name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, data));
      if (typeof window.gtag === 'function') window.gtag('event', name, data);
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* never block navigation */ }
  }

  // ---------- UI ----------
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init(root) {
    if (root.__askKitch) return;
    root.__askKitch = true;

    var form = root.querySelector('.ask-kitch__form');
    var input = root.querySelector('.ask-kitch__input');
    var box = root.querySelector('.ask-kitch__results');
    var status = root.querySelector('.ask-kitch__status');
    var articles = [];
    try { articles = JSON.parse(root.querySelector('[data-ask-kitch-articles]').textContent || '[]'); } catch (e) {}

    var current = [];     // flat list of options currently shown
    var active = -1;
    var lastQ = '';
    var suggestTimer = null;
    var suggestCtl = null;

    function optHTML(o, i, top) {
      var id = input.id + '-opt-' + i;
      return '<a class="ask-kitch__opt' + (top ? ' ask-kitch__opt--top' : '') + '" id="' + id + '" role="option" aria-selected="false" href="' + esc(o.u) + '"' +
        (o.ext ? ' target="_blank" rel="noopener"' : '') + ' data-i="' + i + '">' +
        '<span class="ask-kitch__opt-text"><span class="ask-kitch__opt-title">' + esc(o.t) + '</span>' +
        (o.d ? '<span class="ask-kitch__opt-desc">' + esc(o.d) + '</span>' : '') + '</span>' +
        '<span class="ask-kitch__opt-arrow" aria-hidden="true">&rarr;</span></a>';
    }

    function render(res, live) {
      current = [];
      var html = '';
      if (res.pages.length) {
        html += '<p class="ask-kitch__group">Best match</p>';
        res.pages.forEach(function (o, idx) { html += optHTML(o, current.length, idx === 0); current.push(o); });
      }
      if (res.articles.length) {
        html += '<p class="ask-kitch__group">Read more</p>';
        res.articles.forEach(function (o) { html += optHTML(o, current.length, false); current.push(o); });
      }
      if (live && live.length) {
        html += '<p class="ask-kitch__group">Also on mykitch.ca</p>';
        live.forEach(function (o) { html += optHTML(o, current.length, false); current.push(o); });
      }
      var fallback = { t: 'Search the whole site for “' + lastQ + '”', u: '/search?q=' + encodeURIComponent(lastQ), d: '', fallback: true };
      var human = { t: 'Still stuck? Talk to a person', u: '/pages/help-centre', d: 'The Kitch team can point you in the right direction.' };
      html += '<p class="ask-kitch__group">Something else</p>' + optHTML(fallback, current.length, false);
      current.push(fallback);
      if (!res.pages.length) { html += optHTML(human, current.length, false); current.push(human); }

      box.innerHTML = html;
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      active = -1;
      input.removeAttribute('aria-activedescendant');
      var n = res.pages.length + res.articles.length + (live ? live.length : 0);
      status.textContent = n ? n + ' suggestions. Use up and down arrows to choose.' : 'No direct match. Press Enter to search the whole site.';
    }

    function close() {
      box.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }

    function setActive(i) {
      var opts = box.querySelectorAll('.ask-kitch__opt');
      if (!opts.length) return;
      active = (i + opts.length) % opts.length;
      opts.forEach(function (el, k) { el.setAttribute('aria-selected', k === active ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', opts[active].id);
      opts[active].scrollIntoView({ block: 'nearest' });
    }

    function liveSuggest(q, res) {
      if (suggestCtl && suggestCtl.abort) suggestCtl.abort();
      if (res.pages.length >= 3 || q.length < 3) return;
      suggestCtl = window.AbortController ? new AbortController() : null;
      var url = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') +
        'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,page,article&resources[limit]=4&resources[options][unavailable_products]=hide';
      fetch(url, suggestCtl ? { signal: suggestCtl.signal } : {})
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || q !== lastQ) return;
          var rs = (j.resources && j.resources.results) || {};
          var seen = {};
          res.pages.concat(res.articles).forEach(function (o) { seen[o.u] = 1; });
          var live = [];
          (rs.products || []).forEach(function (p) { live.push({ t: p.title, u: p.url.split('?')[0], d: 'Product' }); });
          (rs.pages || []).forEach(function (p) { live.push({ t: p.title, u: p.url.split('?')[0], d: 'Page' }); });
          (rs.articles || []).forEach(function (p) { live.push({ t: p.title, u: p.url.split('?')[0], d: 'Blog' }); });
          live = live.filter(function (o) { if (seen[o.u]) return false; seen[o.u] = 1; return true; }).slice(0, 4);
          if (live.length) render(res, live);
        })
        .catch(function () {});
    }

    function update() {
      var q = input.value.trim();
      lastQ = q;
      if (q.length < 2) { close(); return; }
      var res = resolve(q, articles);
      render(res);
      clearTimeout(suggestTimer);
      suggestTimer = setTimeout(function () { liveSuggest(q, res); }, 220);
    }

    function go(o, how) {
      var q = input.value.trim();
      var data = {
        ask_query: q.slice(0, 160),
        ask_destination: o.u,
        ask_destination_title: o.t,
        ask_matched: !o.fallback,
        ask_method: how
      };
      track('ask_kitch_search', data);
      if (o.fallback) track('ask_kitch_no_match', { ask_query: q.slice(0, 160) });
      if (o.ext) { window.open(o.u, '_blank', 'noopener'); return; }
      window.location.href = o.u;
    }

    input.addEventListener('input', update);
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2) update(); });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (box.hidden) update(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape' && !box.hidden) { e.stopPropagation(); close(); }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = input.value.trim();
      if (!q) { input.focus(); return; }
      lastQ = q;
      if (active >= 0 && current[active]) { go(current[active], 'keyboard'); return; }
      var res = resolve(q, articles);
      if (res.pages.length) go(res.pages[0], 'enter');
      else if (res.articles.length) go(res.articles[0], 'enter');
      else go({ t: 'Site search', u: '/search?q=' + encodeURIComponent(q), fallback: true }, 'enter');
    });

    box.addEventListener('mousedown', function (e) { e.preventDefault(); }); // keep focus on input
    box.addEventListener('click', function (e) {
      var a = e.target.closest('.ask-kitch__opt');
      if (!a) return;
      e.preventDefault();
      var o = current[+a.getAttribute('data-i')];
      if (o) go(o, 'click');
    });

    root.querySelectorAll('.ask-kitch__chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        input.value = chip.getAttribute('data-q');
        input.focus();
        update();
        track('ask_kitch_chip', { ask_query: input.value });
      });
    });

    document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
  }

  // ---------- Header search icon -> Ask Kitch ----------
  var TRIGGERS = '[data-popdown-toggle="search-popdown"], a[href="#ask-kitch"]';
  var lastFocus = null;

  function homeSection() { return document.querySelector('[data-ask-kitch-home]'); }
  function modal() { return document.querySelector('[data-ask-kitch-modal]'); }

  function focusInput(root) {
    var inp = root && root.querySelector('.ask-kitch__input');
    if (inp) { try { inp.focus({ preventScroll: true }); } catch (e) { inp.focus(); } }
  }

  function openModal(source) {
    var m = modal();
    if (!m) return false;
    lastFocus = document.activeElement;
    m.hidden = false;
    document.documentElement.classList.add('ask-kitch-lock');
    setTimeout(function () { focusInput(m); }, 30);
    track('ask_kitch_open', { ask_open_source: source, ask_open_mode: 'popup' });
    return true;
  }

  function closeModal() {
    var m = modal();
    if (!m || m.hidden) return;
    m.hidden = true;
    document.documentElement.classList.remove('ask-kitch-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openAsk(source) {
    var home = homeSection();
    if (home) {
      home.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(function () { focusInput(home); }, 450);
      track('ask_kitch_open', { ask_open_source: source, ask_open_mode: 'scroll' });
      return true;
    }
    return openModal(source);
  }

  // Capture phase on window so this runs before the theme's own search pop-down handler.
  window.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest(TRIGGERS);
    if (!t || e.metaKey || e.ctrlKey || e.shiftKey) return;
    if (!homeSection() && !modal()) return; // nothing to show: fall back to normal search
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    openAsk(t.matches('[data-popdown-toggle]') ? 'header_icon' : 'link');
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-ask-kitch-close]')) { e.preventDefault(); closeModal(); }
  });
  document.addEventListener('keydown', function (e) {
    var m = modal();
    if (!m || m.hidden) return;
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key === 'Tab') { // keep focus inside the pop-up
      var f = m.querySelectorAll('button, input, a[href]');
      var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  function boot() {
    document.querySelectorAll('[data-ask-kitch]').forEach(init);
    if (location.hash === '#ask-kitch' && !homeSection()) openModal('url_hash');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
